export enum GeoTestResultView {
  conversion = 'Conversions',
  revenue = 'Revenue',
  contributionOnly = 'contributionOnly'
}
